import instance from "@/services/api"
import { ListResource } from "@/utils/ListResource"
import type { User } from "@/types/user"
import type { Pagination } from "@/types/pagination"

export class UserApi extends ListResource {
  public createUser = (data: FormData) =>
    instance.post("/api/v1/register", data, {
      headers: { "Content-Type": "multipart/form-data" }
    })

  public updateUser = (data: FormData, username: string) =>
    instance.put(`/api/v1/users/${username}`, data, {
      headers: { "Content-Type": "multipart/form-data" }
    })

  public deleteUserImage = (username: string) =>
    instance.delete(`/api/v1/users/${username}/profile-image`)

  public getUser = (username: string) =>
    instance.get<User>(`/api/v1/single/${username}`)

  public getUserByToken = () => instance.get<User>("/api/v1/user_by_token")

  public getAllUsers = (
    page: number,
    search = "",
    order = "",
    perPage = 12
  ) => {
    this.setPage(page)
    this.setPerPage(perPage)
    this.setSearch(search)
    this.setOrder(order)

    const filterString = this.search ? `?filter=${this.search}` : ""
    const sortString = this.order_by
      ? this.search
        ? `&sort=${this.order_by}`
        : `?sort=${this.order_by}`
      : ""

    return instance.get<Pagination<User>>(
      `/api/v1/all_users${filterString}${sortString}`,
      {
        params: {
          page: this.page,
          page_size: this.per_page
        }
      }
    )
  }
}
